<h1 mat-dialog-title><i class="fas fa-2x fa-check-circle"></i></h1>
<div mat-dialog-content><h2>L' article a été ajouté au panier avec succès !</h2></div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="valider-panier">
      <a [routerLink]="[ '/cart']" title="panier">Voir panier</a>
  </button>
  <button mat-button mat-dialog-close class="valider-panier">Ok</button>
</mat-dialog-actions>
